<template>
    <div>
      <div class="mt-3 period-selector">
        <b-button-group>
        <span v-for="(intervalButton, index) in intervalButtons" :key="'intervalButton-' + index">
          <b-button
              class="internal-button"
              :variant="intervalButton.active ? 'active' : ''"
              @click="changeInterval(intervalButton)"
              :key="updateKey"
          >
            {{ $cte(intervalButton.label) }}
          </b-button>
        </span>
        </b-button-group>
      </div>

      <h3 class="text-center" v-if="errorMsg" style="color: red">
        {{ errorMsg }}
      </h3>
      
        <b-overlay class="mt-3 mb-3">
          <span class="period-label font-poppins"> {{ $cte("flatRate.informText") }} </span>
          <div class="d-flex flex-row align-items-center align-items-stretch mt-3 reportSliderContainer" >
            <div class="paging-div mr-4 desktop-only"  @click="pageLeft">
              <i class="fas fa-angle-left"></i>
            </div>
            <div class="mt-4 relative w-100">
              
              <div class=" justify-content-center spacing mb-4 desktop-only">
                <div v-if="activeInterval === 'yearly'" class="title" >{{yearPointer}}</div>
                <div v-if="activeInterval === 'quarterly'" class="title" >{{yearPointer}} {{hungarianQuarters[quarterPointer]}}</div>
                <div v-if="activeInterval === 'monthly'" class="title" >{{yearPointer}} {{hungarianMonths[monthPointer]}}</div>
              </div>
  
              <div class="mobile-only">
                <div class="d-flex flex-row align-items-center align-items-stretch spacing-2 card-container" >
                  <div class="paging-div mr-4"  @click="pageLeft">
                    <i class="fas fa-angle-left"></i>
                  </div>
                  <div class="mt-4 relative container-style">
                    <div class="d-flex justify-content-center spacing mb-4">
                      <div v-if="activeInterval === 'yearly'" class="title" >{{yearPointer}}</div>
                      <div v-if="activeInterval === 'quarterly'" class="title" >{{yearPointer}} {{hungarianQuarters[quarterPointer]}}</div>
                      <div v-if="activeInterval === 'monthly'" class="title" >{{yearPointer}} {{hungarianMonths[monthPointer]}}</div>
                    
                    </div>
                  </div>
                  <div
                  class="paging-div ml-4"
                  @click="pageRight"
                  >
                    <i class="fas fa-angle-right"></i>
                  </div>
                </div>
              </div>
  
              <b-container class="card-parent" fluid>
                <b-row>
                    <b-col cols="12" xl="4">
                        <atalany-paid-card
                            title="FIZETENDŐ"
                            :szja="activeInterval === 'monthly' ? selected58MonthData.szja : activeInterval === 'quarterly' ? selected58QuarterData.szja : selected58AnnualData.szja"
                            :tb="activeInterval === 'monthly' ? selected58MonthData.tb : activeInterval === 'quarterly' ? selected58QuarterData.tb : selected58AnnualData.tb"
                            :szocho="activeInterval === 'monthly' ? selected58MonthData.szocho : activeInterval === 'quarterly' ? selected58QuarterData.szocho : selected58AnnualData.szocho"
                        />
                    </b-col>
                    <b-col cols="12" xl="4">
                        <atalany-paid-card
                            v-if="activeInterval === 'monthly'"
                            title="BEFIZETETT"
                            :editable="activeInterval === 'monthly'"
                            :szja.sync="selectedMonthData.value.szja"
                            :tb.sync="selectedMonthData.value.tb"
                            :szocho.sync="selectedMonthData.value.szocho"
                            @saveMonthlyData="saveMonthlyData"
                        />
                        <atalany-paid-card
                            v-else
                            title="BEFIZETETT"
                            :szja="activeInterval === 'monthly' ? selectedMonthData.value.szja : activeInterval === 'quarterly' ? selectedQuarterData.value.szja : selectedAnnualData.value.szja"
                            :tb="activeInterval === 'monthly' ? selectedMonthData.value.tb : activeInterval === 'quarterly' ? selectedQuarterData.value.tb : selectedAnnualData.value.tb"
                            :szocho="activeInterval === 'monthly' ? selectedMonthData.value.szocho : activeInterval === 'quarterly' ? selectedQuarterData.value.szocho : selectedAnnualData.value.szocho"
                        />
                    </b-col>
                    <b-col cols="12" xl="4">
                         <atalany-paid-card
                            title="EGYENLEG"
                            :szja="activeInterval === 'monthly' ? selected58MonthData.szjaBalance : activeInterval === 'quarterly' ? selected58QuarterData.szjaBalance : selected58AnnualData.szjaBalance"
                            :tb="activeInterval === 'monthly' ? selected58MonthData.tbBalance : activeInterval === 'quarterly' ? selected58QuarterData.tbBalance : selected58AnnualData.tbBalance"
                            :szocho="activeInterval === 'monthly' ? selected58MonthData.szochoBalance : activeInterval === 'quarterly' ? selected58QuarterData.szochoBalance : selected58AnnualData.szochoBalance"
                        />
                    </b-col>
                </b-row>
              </b-container>
           </div>
            <div
              @click="pageRight"
              class="paging-div desktop-only"
            >
              <i class="fas fa-angle-right"></i>
            </div>
        </div>
      </b-overlay>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import AtalanyPaidCard from "@/views/app/invoicing/AtalanyPaidCard";
  import Api from "api-client/index";
  
  export default {
    name: "AtalanyView",
  
    components: { AtalanyPaidCard },
  
    computed: {
      ...mapGetters("app", ["getActiveCompany"]),
    },
  
    data() {
      return {
        errorMsg: null,
        loaded: false,
  
        currentYear: new Date().getFullYear(),
        yearPointer: new Date().getFullYear(),
        monthPointer: new Date().getMonth(),
        quarterPointer:
          new Date().getMonth() % 3,
        actualMonth: new Date().getMonth(),
        selectedAnnualData: {},
        selectedQuarterData: {},
        selectedMonthData: {},
        selected58AnnualData: {},
        selected58QuarterData: {},
        selected58MonthData: {},
        intervalButtons: [
          {
            label: "vat.monthly",
            active: false,
            value: "monthly",
          },
          {
            label: "vat.quarterly",
            active: true,
            value: "quarterly",
          },
          {
            label: "vat.annual",
            active: false,
            value: "yearly",
          },
        ],
        hungarianMonths :[
          "január",
          "február",
          "március",
          "április",
          "május",
          "június",
          "július",
          "augusztus",
          "szeptember",
          "október",
          "november",
          "december"
        ],
        hungarianQuarters : [
          "I. negyedév",
          "II. negyedév",
          "III. negyedév",
          "IV. negyedév"
        ],
        activeInterval: "quarterly",
        updateKey: 0
      };
    },
  
    created() {
      this.getAdvancedPayment();
      this.get58();
    },
  
    methods: {
      changeInterval(intervalData) {
        this.intervalButtons.forEach((button) => {
          button.active = false;
        });
  
        this.activeInterval = intervalData.value;
        intervalData.active = true;
  
        
        this.getAdvancedPayment();
        this.get58();
      },
      
      pageLeft() {
        if(this.activeInterval === "monthly") {
          if ((this.yearPointer === 2023 && this.monthPointer === 0) || this.yearPointer < 2023) {
            return;
          }

          if (this.monthPointer <= 0) {
            this.yearPointer = this.yearPointer - 1;
            this.monthPointer = 11;
          } else {
            this.monthPointer = this.monthPointer - 1;
          }
        }

        

        if(this.activeInterval === "quarterly") {
          if ((this.yearPointer === 2023 && this.quarterPointer === 0) || this.yearPointer < 2023) {
            return;
          }

          if (this.quarterPointer <= 0) {
            this.yearPointer = this.yearPointer - 1;
            this.quarterPointer = 3;
          } else {
            this.quarterPointer = this.quarterPointer - 1;
          }
        }
  
        if(this.activeInterval === "yearly") {
          if (this.yearPointer <= 2023) {
            return;
          }

          this.yearPointer = this.yearPointer - 1;
        }
        this.getAdvancedPayment();
        this.get58();
      },
  
      pageRight() {
        if(this.activeInterval === "monthly") {
          if (this.currentYear === this.yearPointer && this.monthPointer >= 11) {
            return;
          }

          if (this.monthPointer >= 11) {
            this.yearPointer = this.yearPointer + 1;
            this.monthPointer = 0;
          } else {
            this.monthPointer = this.monthPointer + 1;
          }
        }

        if(this.activeInterval === "quarterly") {
          if (this.currentYear === this.yearPointer && this.quarterPointer >= 3) {
            return;
          }
  
          if (this.quarterPointer >= 3) {
            this.yearPointer = this.yearPointer + 1;
            this.quarterPointer = 0;
          } else {
            this.quarterPointer = this.quarterPointer + 1;
          }
        }
        if(this.activeInterval === "yearly") {
          if (this.currentYear === this.yearPointer) {
            return;
          }
          this.yearPointer = this.yearPointer + 1;
        } 
  
        this.getAdvancedPayment();
        this.get58();
      },
  
      calculateOffsetYearPointer(year, month, offset) {
        if (month + offset > 11) {
          return year + 1;
        }
        return year;
      },
  
      getAdvancedPayment(){
          Api.getAdvancedPayment(this.getActiveCompany.id, this.yearPointer).then((resp) => {
            this.selectedAnnualData = resp.data.annual;
            this.selectedQuarterData = resp.data.quarters.find(i => i.quarter === this.quarterPointer);
            this.selectedMonthData = resp.data.months.find((i) => i.month === this.monthPointer)
          this.loaded = true;
        }).catch((err) => {
          console.log(err);
        });
      },
      get58(){
        Api.getPayableTaxes(this.getActiveCompany.id, this.yearPointer).then((resp) => {
          this.selected58AnnualData = resp.data.annual;
          this.selected58QuarterData = resp.data.quarters.find(i => i.quarterOrder === this.quarterPointer);
          this.selected58MonthData = resp.data.months.find((i) => i.monthOrder === this.monthPointer);
        this.loaded = true;
        }).catch((err) => {
          console.log(err);
        });
      },

      saveMonthlyData(){
        console.log("JER")
        Api.saveAdvancedPayment({
          companyId: this.getActiveCompany.id,
          year: this.yearPointer,
          month: this.monthPointer,
          values: this.selectedMonthData.value
          }).then(() => {
            this.$toast.success({
              title: this.$cte("toast.success"),
              message: this.$cte("toast.modify-success"),
            });
            this.get58();
            this.getAdvancedPayment();
        this.loaded = true;
        }).catch((err) => {
          console.log(err);
        });
      }
      
    },
  };
  </script>
  
  <style scoped>
  .progress {
    height: 30px;
    margin-bottom: 5px;
    background-color: #2ab951;
  }
  
  .progress-bar {
    background-color: #008200;
  }
  
  .inform-text {
    font-family: Poppins;
    font-weight: bold;
    color: #b5b5c4;
    margin: 0 3.2rem;
  }
  
  .internal-button {
    min-width: 100%;
  }

  .period-selector {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    background-color: #252734;
    border-radius: 32px;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .period-selector::-webkit-scrollbar {
    display: none;
  }

  .period-selector >>> .btn-group {
    display: inline-flex;
    flex-wrap: nowrap;
    min-width: max-content;
  }

  .period-selector >>> .btn-group > span,
  .period-selector >>> .btn-group .btn {
    flex: 0 0 auto;
    white-space: nowrap;
  }

  .card-parent {
    width: 100%;
  }

  .paging-div {
    padding: 0.6rem;
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    color: #b2ec5d;
    background-color: #252734;
    font-size: 1rem;
    border-radius: 22px;
    cursor: pointer;
  }

  .paging-div:hover {
    background-color: #b2ec5d !important;
    color: #252734 !important;
  }

  .paging-div.disabled {
    color: gray;
  }
  
  .data {
    background-color: #f3f6f9;
  }
  .footnote {
    text-align: right;
    margin-right: 3rem;
    color: #2ab950;
    font-weight: bold;
    font-size: 0.9rem;
  }
  
  @media screen and (max-width: 1246px) {
    .inform-text {
      margin: 0;
    }
  
  
    .footnote {
      font-size: 1.1rem;
    }
  }
  
  /* Remove padding by default */
  .custom-padding {
    padding: 0.2rem; 
  }
  
  
  /* Remove padding again on lg viewport */
  @media (min-width: 992px) {
    .custom-padding {
      padding: 0;
    }
  }
  
  .period-label {
    font-weight: 400;
  
    color: rgba(0, 0, 0, 0.52);
  }
  
  .title {
    font-family: Jumper;
    font-size: 2rem;
    text-align: center;
    width: 100%;
    padding: 0.25rem;
    margin: 0 0.8rem;
    margin-bottom: 0.25rem;
    border: none;
    max-width: 400px;
  }
  .card-body {
    width: 100%;
    padding-left: 4rem;
    padding-right: 4rem;
    margin: 0 auto;
  }
  .desktop-only {
    display: none;
  }
  @media screen and (min-width: 1246px) {
    .desktop-only { 
      display: flex;
    }
  }
  .card-container {
    width: fit-content;
    margin: 0 auto;
  }
  .mobile-only {
    display: none;
  }
  
  @media screen and (max-width: 1246px) {
  
    .card-body {
      padding-left: 0rem !important;
      padding-right: 0rem !important;
      margin: 0 auto;
    }
    .mobile-only {
      display: flex;
    }
  }

  .reportSliderContainer {
    border: 1px solid #252734;
    border-radius: 32px;
    padding: 20px;
  }
  </style>
  
